module.exports = __webpack_public_path__ + "static/2-f861f1d8d0ac3234148fa5b7b6debda0.png";